// extracted by mini-css-extract-plugin
export default {"inline":"TaskResponsible_inline__idiOB","task_responsible":"TaskResponsible_task_responsible__tEI70"};